import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import { ILanguages } from "@/apps/merchant3/models/ILanguages";

export const getLanguages = async (): Promise<AxiosResponse<ILanguages>> => {
  return await jwtApiClient.get(M3_API().GET_COUNTRY_LANGUAGES);
};
